import { render } from "./DefaultOptionsSelector.vue?vue&type=template&id=247ee3a8&scoped=true"
import script from "./DefaultOptionsSelector.vue?vue&type=script&lang=js"
export * from "./DefaultOptionsSelector.vue?vue&type=script&lang=js"

import "./DefaultOptionsSelector.vue?vue&type=style&index=0&id=247ee3a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247ee3a8"]])

export default __exports__